import {
	Container,
	ContainerGutter,
	styled,
	Text,
	TextAlignment,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { HuchaPosventaValues } from '../../../shared/models/hucha-values';
import { LogoBonoPosventa } from '../../assets/logo-bono-posventa';
import { BonoPosventaButtonAndStatus } from '../ui/bono-posventa-button-status';

const HuchaLogoWrapper = styled.div`
	width: 100%;
	min-width: 200px;
	max-width: 250px;
`;

const AlignedContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: fit-content;
	gap: 20px;
`;

export const BonoPosventaCardC1 = ({ huchaValues }: { huchaValues: HuchaPosventaValues }) => {
	return (
		<Container data-testid="card-c1-container" gutter={ContainerGutter.static200} stretchContent wrap="always">
			<HuchaLogoWrapper>
				<LogoBonoPosventa />
			</HuchaLogoWrapper>
			<AlignedContainer>
				<Text
					appearance={TokenTextAppearance.headline100}
					color={TokenTextColor.primary}
					textAlign={TextAlignment.left}
					bold
				>
					{'Gracias por dejarnos cuidar de ti y de tu coche. ¡Aquí tienes tu regalo de bienvenida!'}
				</Text>
				<BonoPosventaButtonAndStatus huchaValues={huchaValues} />
			</AlignedContainer>
		</Container>
	);
};
